import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-grid-3 py-grid-1 text-size-xs font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 will-change-transform hover:scale-105",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary-hover shadow-elevation-1 hover:shadow-elevation-2",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary-hover shadow-elevation-1 hover:shadow-elevation-2",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80 shadow-elevation-1 hover:shadow-elevation-2",
        success:
          "border-transparent bg-success text-success-foreground hover:bg-success/80 shadow-elevation-1 hover:shadow-elevation-2",
        warning:
          "border-transparent bg-warning text-warning-foreground hover:bg-warning/80 shadow-elevation-1 hover:shadow-elevation-2",
        outline: "text-foreground border-border hover:border-border-hover hover:bg-accent/50",
        glass: "border-border/30 bg-surface-glass text-foreground hover:border-border-hover/50 backdrop-blur-sm shadow-elevation-1 hover:shadow-elevation-2",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => (
    <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
  )
)
Badge.displayName = "Badge"

export { Badge, badgeVariants }
